<template>
  <tr>
    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      {{ thirdPartyService.service }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ thirdPartyService.channel }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      <ThirdPartyServiceActiveToggleButton
        :value="thirdPartyService.active"
        :third-party-service-id="thirdPartyService.id"
      />
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
      <VDropdown theme="ghost" placement="bottom-end">
        <button
          type="button"
          class="p-2 rounded-full bg-transparent hover:bg-gray-200 focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <circle cx="12" cy="12" r="1" />
            <circle cx="12" cy="19" r="1" />
            <circle cx="12" cy="5" r="1" />
          </svg>
        </button>
        <template #popper>
          <div
            class="max-w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <div class="py-1">
              <button
                type="button"
                class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                role="menuitem"
                v-close-popper
                @click="editThirdPartyService"
              >
                Edit
              </button>
            </div>
            <div class="py-1">
              <button
                type="button"
                class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-red-700 hover:bg-red-100 hover:text-red-900"
                role="menuitem"
                v-close-popper
                @click="destroyThirdPartyService"
              >
                Delete
              </button>
            </div>
          </div>
        </template>
      </VDropdown>
    </td>
  </tr>
</template>

<script>
import ThirdPartyServiceActiveToggleButton from './ThirdPartyServiceActiveToggleButton.vue';

export default {
  components: {
    ThirdPartyServiceActiveToggleButton,
  },
  props: {
    thirdPartyService: {
      type: Object,
      required: true,
    },
  },
  methods: {
    editThirdPartyService() {
      this.$modal.show({
        component: () => import('./CustomEmailServiceDialog.vue'),
        props: {
          accountId: this.thirdPartyService.accountId,
          customEmailIntegrationId: this.thirdPartyService.id,
        },
        on: {},
        hideEvent: 'close',
      });
    },
    destroyThirdPartyService() {
      const vm = this;

      this.$modal.show({
        component: 'ThirdPartyServiceDestroyModal',
        props: {
          thirdPartyServiceId: this.thirdPartyService.id,
        },
        on: {
          destroyed: () => {
            vm.afterDestroy();
          },
        },
        hideEvent: 'hide',
      });
    },
    afterDestroy() {
      this.$store.commit('ui/accountThirdPartyServices/removeIdFromParent', {
        parentId: this.thirdPartyService.accountId,
        id: this.thirdPartyService.id,
      });
    },
  },
};
</script>
